export class DataClassificationEntity {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "resourceId",
            "baseName": "resourceId",
            "type": "string",
            "format": ""
        },
        {
            "name": "entityType",
            "baseName": "entityType",
            "type": "string",
            "format": ""
        },
        {
            "name": "dataLocation",
            "baseName": "dataLocation",
            "type": "{ [key: string]: any; }",
            "format": ""
        },
        {
            "name": "categories",
            "baseName": "categories",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return DataClassificationEntity.attributeTypeMap;
    }
    constructor() {
    }
}
